import React from 'react';
import PropTypes from 'prop-types';

export const CorporateFare = ({ width, height, ...props }) => (
  <svg
    data-icon='corporate-fare'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M2 21V3h10v4h10v14H2Zm2-2h6v-2H4v2Zm0-4h6v-2H4v2Zm0-4h6V9H4v2Zm0-4h6V5H4v2Zm8 12h8V9h-8v10Zm2-6v-2h4v2h-4Zm0 4v-2h4v2h-4Z'
    />
  </svg>
);

CorporateFare.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

CorporateFare.defaultProps = {
  width: 24,
  height: 24,
};
